import {create} from 'zustand';
import {RefundDocumentRow} from '../../components/SendDocuments/types';

type UseRefundDocumentsStoreProps = {
	rows: RefundDocumentRow[];
	modalityKey: string | null;
	seedRows: (rows: RefundDocumentRow[], modalityKey: string) => void;
	updateRow: (id: string, updates: Partial<RefundDocumentRow>) => void;
	reset: () => void;
};

export const useRefundDocumentsStore = create<UseRefundDocumentsStoreProps>(set => ({
	rows: [],
	modalityKey: null,
	seedRows: (rows, modalityKey) => set({rows, modalityKey}),
	updateRow: (id, updates) =>
		set(state => ({
			rows: state.rows.map(row => (row.id === id ? {...row, ...updates} : row)),
		})),
	reset: () => set({rows: [], modalityKey: null}),
}));
